import React, { useEffect, useState } from 'react';
import PublicationLegend from './publicationsModule/PublicationLegend.tsx';
import DesktopPublication from './publicationsModule/DesktopPublication.tsx';
import MobilePublication from './publicationsModule/MobilePublication.tsx';
import { useBulletStyles } from './publicationsModule/useBulletStyles.ts';

const Publication: React.FC = () => {
    const [isMd, setIsMd] = useState(window.matchMedia('(min-width: 67.5rem)').matches);
    const { BulletMainAuthor, BulletMajorAuthor, BulletCommon } = useBulletStyles();

    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 67.5rem)');
        const updateIsMd = () => {
            setIsMd(mediaQuery.matches);
        };

        mediaQuery.addListener(updateIsMd);
        return () => {
            mediaQuery.removeListener(updateIsMd);
        };
    }, []);

    return (
        <div className='flex flex-col justify-start items-left md:items-center'>
            <br />
            <p
                className='text-textGrey font-condensed text-center font-extrabold text-2xl'
                id='publication'
            >
                PUBLICATION
            </p>
            <PublicationLegend
                BulletMainAuthor={BulletMainAuthor}
                BulletMajorAuthor={BulletMajorAuthor}
            />
            <br />
            {isMd ? (
                <DesktopPublication
                    BulletMainAuthor={BulletMainAuthor}
                    BulletMajorAuthor={BulletMajorAuthor}
                    BulletCommon={BulletCommon}
                />
            ) : (
                <MobilePublication
                    BulletMainAuthor={BulletMainAuthor}
                    BulletMajorAuthor={BulletMajorAuthor}
                    BulletCommon={BulletCommon}
                />
            )}
            <br />
        </div>
    );
};

export default Publication;
